/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import TranslationProvider from '../../providers/TranslationProvider';
import { EmailForm } from '../Form';
import containerQueryProps from '../../props/containerQueryProps';
import {
  AUTH_ACTIONS,
  AUTH_FLOWS,
  AUTH_METHODS,
  AUTH_STEPS,
  buildAuthDdActionName,
  trackAuthDdAction,
} from '../../utils/authDatadog';

import './Auth.scss';

const ChallengeView = ({
  onEmailCodeRequest,
  onSubmit,
  onSignupClick,
  containerQuery: { sm },
  firstName,
  processing,
}) => (
  <div className={cx('AuthView', {
    'AuthView--sm': sm,
  })}
  >
    <TranslationProvider
      translationKey="onboarding.challenge_title"
      translationValues={{
        firstName,
      }}
    >
      <div className="AuthView__Text--bold" style={{ marginBottom: '10px' }}>
        {`Hey ${firstName}, is that you? `}
      </div>
    </TranslationProvider>
    <TranslationProvider
      translationKey="onboarding.challenge_copy"
    >
      <div className="AuthView__Text--light" style={{ marginBottom: '30px' }}>
        Please verify your account by entering the email address associated with the account:
      </div>
    </TranslationProvider>

    <EmailForm
      onSubmit={onSubmit}
      processing={processing}
      autoFocus
      datadogActionName={buildAuthDdActionName({
        flow: AUTH_FLOWS.SIGN_IN,
        method: AUTH_METHODS.EMAIL_PASS,
        step: AUTH_STEPS.CAPTURE_EMAIL,
        action: AUTH_ACTIONS.CONTINUE,
      })}
    />
    <div className="AuthView__Option">
      <TranslationProvider
        translationKey="onboarding.request_email_code"
      >
        <button
          onClick={() => {
            const actionName = buildAuthDdActionName({
              flow: AUTH_FLOWS.SIGN_IN,
              method: AUTH_METHODS.EMAIL_CODE,
              step: AUTH_STEPS.CAPTURE_EMAIL,
              action: AUTH_ACTIONS.REQUEST_EMAIL_CODE,
            });
            trackAuthDdAction(actionName, { source: 'auth' });
            onEmailCodeRequest();
          }}
          type="button"
          data-dd-action-name={buildAuthDdActionName({
            flow: AUTH_FLOWS.SIGN_IN,
            method: AUTH_METHODS.EMAIL_CODE,
            step: AUTH_STEPS.CAPTURE_EMAIL,
            action: AUTH_ACTIONS.REQUEST_EMAIL_CODE,
          })}
        >
          Or, Log in with a one-time use code
        </button>
      </TranslationProvider>
    </div>
    <div className="AuthView__Divider" style={{ marginTop: '40px' }} />
    <div className={cx('AuthView__Footer', {
      'AuthView__Footer--sm': sm,
    })}
    >
      <TranslationProvider
        translationKey="onboarding.not_first_name"
        translationValues={{
          firstName,
        }}
      >
        <span>{`Not ${firstName}? `}</span>
      </TranslationProvider>
      <TranslationProvider
        translationKey="onboarding.create_new_account"
      >
        <button
          onClick={() => {
            const actionName = buildAuthDdActionName({
              flow: AUTH_FLOWS.SIGN_UP,
              method: AUTH_METHODS.PHONE_CODE,
              step: AUTH_STEPS.CAPTURE_EMAIL,
              action: AUTH_ACTIONS.OPEN_SIGN_UP,
            });
            trackAuthDdAction(actionName, { source: 'auth' });
            onSignupClick();
          }}
          type="button"
          data-dd-action-name={buildAuthDdActionName({
            flow: AUTH_FLOWS.SIGN_UP,
            method: AUTH_METHODS.PHONE_CODE,
            step: AUTH_STEPS.CAPTURE_EMAIL,
            action: AUTH_ACTIONS.OPEN_SIGN_UP,
          })}
        >
          Create a new account
        </button>
      </TranslationProvider>
    </div>
  </div>
);

ChallengeView.propTypes = {
  onEmailCodeRequest: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  containerQuery: containerQueryProps,
  firstName: PropTypes.string.isRequired,
  processing: PropTypes.bool,
};

ChallengeView.defaultProps = {
  containerQuery: {},
  processing: false,
};

export default ChallengeView;
